import { defineComponent, reactive } from 'vue';
import { useRouter } from 'vue-router';
export default defineComponent({
  name: 'Header',
  props: {
    infos: String
  },
  setup() {
    const currentEnv = process.env.NODE_ENV;
    const userStr = localStorage.getItem('user');
    let user = {};
    if (userStr) {
      user = JSON.parse(userStr);
    }
    const data = reactive({
      nickname: user.nickname,
      figureurl: user.figureurl_qq,
      confirmed: user.confirmed
    });
    // https://sdi.3g.qq.com/v/2022121520181511711
    const goUserAgreement = () => {
      // 水滴 主页-帮助文档按钮点击
      window._sdi.stat({
        ptype: '9',
        stype: '8'
      });
      window.open('https://sdi.3g.qq.com/v/2022121520181511711');
    };
    // 帮助文档下拉选项
    const helpOptions = [{
      content: '开放平台指引',
      value: 3
    }, {
      content: '应用审核规则',
      value: 2
    }, {
      content: '侵权投诉指引',
      value: 1
    }];
    const handleHelpClick = data => {
      if (data.value === 3) {
        // 开放平台指引
        window._sdi.stat({
          ptype: '9',
          stype: '8'
        });
        window.open('https://sdi.3g.qq.com/v/2022121520181511711');
      } else if (data.value === 2) {
        // 应用审核规则
        window.open('https://sdi.3g.qq.com/v/2026020917224211225');
      } else if (data.value === 1) {
        // 侵权投诉指引
        window.open('https://sdi.3g.qq.com/v/2026020917382311695');
      }
    };
    const editmap = {
      '': '/personaledit',
      1: '/personaledit',
      2: '/companyedit'
    };
    const $router = useRouter();
    const dropdowns = user.confirmed == 2 ? [{
      content: '编辑资料',
      value: 1
    }, {
      content: '退出登录',
      value: 2
    }] : [{
      content: '退出登录',
      value: 2
    }];
    const clickHandler = data => {
      // 编辑资料
      if (data.value == 1) {
        // 水滴 主页-编辑资料按钮点击
        window._sdi.stat({
          ptype: '9',
          stype: '10'
        });
        $router.push({
          path: editmap[user.identityType]
        });
      }
      // 退出登录
      if (data.value == 2) {
        // 水滴 主页-退出登录按钮点击
        window._sdi.stat({
          ptype: '9',
          stype: '11'
        });
        localStorage.setItem('token', '');
        localStorage.setItem('user', '');
        $router.push({
          path: '/login'
        });
      }
    };
    const goContactus = () => {
      // 水滴 主页-联系我们按钮点击
      window._sdi.stat({
        ptype: '9',
        stype: '9'
      });
      window.open('/software-platform/contactus');
    };
    return {
      dropdowns,
      clickHandler,
      currentEnv,
      goUserAgreement,
      goContactus,
      helpOptions,
      handleHelpClick,
      data
    };
  }
});